import React from "react";
import {Icon} from "antd";
import {Link} from "react-router-dom";

function ProfileRow({label, value}) {
    return (
        <div className="profile-card__row">
            <span className="profile-card__label">
                {label}
            </span>

            <span className="profile-card__value">
                {value}
            </span>
        </div>
    );
}

export default function ProfileCard({
                                        profile,
                                        canSwitchUserType,
                                        isSwitching,
                                        onSwitchUserType,
                                        onLogout,
                                        onCabinetNavigate,
                                        cabinetOnboarding,
                                        onCabinetOnboardingDismiss,
                                    }) {
    return (
        <div className="profile-card">
            <div className="profile-card__identity">
                <div className="profile-card__avatar">
                    {profile.initials}
                </div>

                <div className="profile-card__identity-text">
                    <div className="profile-card__name">
                        {profile.name}
                    </div>

                    <div className="profile-card__role">
                        {profile.roleName}
                    </div>
                </div>
            </div>

            {Boolean(canSwitchUserType) && (
                <div className="profile-card__mode">
                    <div className="profile-card__mode-title">
                        <span>{profile.labels.workMode}</span>

                        {isSwitching && (
                            <Icon type="loading"/>
                        )}
                    </div>

                    <div
                        className="profile-card__switch"
                        aria-busy={isSwitching}
                    >
                        <input
                            type="radio"
                            name="profileRole"
                            id="profileRoleOwner"
                            checked={profile.isStaff}
                            disabled={isSwitching}
                            onChange={() =>
                                onSwitchUserType(true)
                            }
                        />

                        <label htmlFor="profileRoleOwner">
                            {profile.labels.ownerMode}
                        </label>

                        <input
                            type="radio"
                            name="profileRole"
                            id="profileRoleCarrier"
                            checked={!profile.isStaff}
                            disabled={isSwitching}
                            onChange={() =>
                                onSwitchUserType(false)
                            }
                        />

                        <label htmlFor="profileRoleCarrier">
                            {profile.labels.carrierMode}
                        </label>
                    </div>
                </div>
            )}

            <div className="profile-card__divider"/>

            {profile.sections.map((section, index) => (
                <React.Fragment key={section.id}>
                    {index > 0 && (
                        <div className="profile-card__divider"/>
                    )}

                    {section.rows.map((row) => (
                        <ProfileRow
                            key={row.id}
                            label={row.label}
                            value={row.value}
                        />
                    ))}
                </React.Fragment>
            ))}
            {cabinetOnboarding && (
                <div className="profile-card__onboarding">
                    <div className="profile-card__onboarding-heading">
                        <span className="profile-card__onboarding-icon">
                            <Icon type="info-circle"/>
                        </span>

                        <strong>
                            {cabinetOnboarding.title}
                        </strong>
                    </div>

                    <p className="profile-card__onboarding-text profile-card__onboarding-text--desktop">
                        {cabinetOnboarding.description}
                    </p>

                    <p className="profile-card__onboarding-text profile-card__onboarding-text--mobile">
                        {cabinetOnboarding.mobileDescription}
                    </p>

                    <button
                        type="button"
                        className="profile-card__onboarding-confirm"
                        onClick={onCabinetOnboardingDismiss}
                    >
                        {cabinetOnboarding.confirm}
                    </button>
                </div>
            )}

            <div className="profile-card__actions">
                <Link
                    className="profile-card__action profile-card__action--cabinet"
                    to={profile.cabinetPath}
                    onClick={onCabinetNavigate}
                >
                    <Icon type="home"/>

                    <span>
                        {profile.labels.openCabinet}
                    </span>
                </Link>

                <Link
                    className="profile-card__action profile-card__action--logout"
                    to="/login"
                    onClick={onLogout}
                >
                    <Icon type="logout"/>

                    <span>{profile.labels.logout}</span>
                </Link>
            </div>
        </div>
    );
}